import { PRODUCT_TYPE } from "../../constants/commonConstants";

const roundUpToIncrement = (value, increment) =>
  Math.ceil(value / increment) * increment;

export const getIncrement = (requestedProductType) => {
  const incrementMap = {
    [PRODUCT_TYPE.PERSONAL_LOAN]: 50,
    [PRODUCT_TYPE.CAR_LOAN]: 1,
    [PRODUCT_TYPE.LINE_OF_CREDIT]: 100,
    [PRODUCT_TYPE.LINE_OF_CREDIT_DRAW_DOWN]: 0.01,
  };

  return incrementMap[requestedProductType] || 1;
};

const stringValueNonParableToFloat = (value) => {
  const loanAmount = parseFloat(value);
  return isNaN(loanAmount);
}

// loanAmountString is expected to be either: null, undefined OR a string representation of a positive number
// if loanAmountString ever gains the ability to be negative more tests will be required
export const calculateRoundedUpLoanAmountNumber = (loanAmountString, requestedProductType) => {
  const loanAmount = parseFloat(loanAmountString);
  const increment = getIncrement(requestedProductType);
  
  if (stringValueNonParableToFloat(loanAmountString)) {
    return 0;
  }
  
  if (requestedProductType === PRODUCT_TYPE.LINE_OF_CREDIT_DRAW_DOWN) {
    return loanAmount;
  }

  return roundUpToIncrement(loanAmount, increment);
};

export const calculateRoundedUpLoanAmount = (loanAmountString, requestedProductType, minAmount = 0) => {
  if (stringValueNonParableToFloat(loanAmountString)) {
    return loanAmountString;
  }

  const roundedUpLoanAmount = Math.max(minAmount, calculateRoundedUpLoanAmountNumber(loanAmountString, requestedProductType));
  return roundedUpLoanAmount === 0 ? "" : "" + roundedUpLoanAmount;
};

export const roundUpLoanAmount = (value, name, requestedProductType, setFieldValue, minAmount = 0) => {
  const loanAmount = calculateRoundedUpLoanAmount(value, requestedProductType, minAmount);

  setFieldValue(name, loanAmount);
};